import { lazy } from 'react'

const CollegesComponent = lazy(async () => {
  const { Colleges } = await import(/* webpackChunkName: "colleges" */ './index')

  return {
    default: Colleges
  }
})
const routes = [
  {
    path: '/colleges',
    render(props) {
      return <CollegesComponent {...props} />
    }
  }
]

export { routes }
